import type { SVGProps } from "react";
import { memo } from "react";
const Timestream = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 80 80" {...props}>
    <defs>
      <linearGradient id="prefix__a" x1="0%" x2="100%" y1="100%" y2="0%">
        <stop offset="0%" stopColor="#2E27AD" />
        <stop offset="100%" stopColor="#527FFF" />
      </linearGradient>
    </defs>
    <g fill="none" fillRule="evenodd">
      <path fill="url(#prefix__a)" d="M0 0h80v80H0z" />
      <path
        fill="#FFF"
        d="M60.92 52.293 62.201 51H56.25l-1.574-1.586-2.976 3-8.638-8.707 1.402-1.414 7.236 7.293 2.976-3L57.071 49h5.131l-1.283-1.293 1.403-1.414L66 50l-3.678 3.707zM51.7 36.586 53.273 35h3.138l2.972 3.332-1.477 1.336L55.527 37h-1.432L51.7 39.414 49.305 37h-5.542v-2h6.363zM62.202 36H60.63v-2h4.96v5h-1.984v-1.586L61.04 40l2.566 2.586V41h1.984v5h-4.96v-2h1.573l-2.565-2.586L57.07 44h-5.953l-1.693 1.707-1.403-1.414L50.297 42h5.953zm-19.14 13.293 1.984-2 1.403 1.414-1.985 2zM32.85 14c9.94 0 16.866 3.162 16.866 6s-6.926 6-16.866 6-16.866-3.162-16.866-6 6.926-6 16.866-6m9.92 19h-1.983v22c0 .552.443 1 .992 1h7.937v4c0 2.838-6.926 6-16.866 6-9.623 0-16.866-3.479-16.866-5.735v-7.591C19.017 55.284 25.267 57 32.85 57c2.464 0 4.858-.189 7.112-.563l-.321-1.974A42 42 0 0 1 32.85 55c-9.94 0-16.866-3.162-16.866-6V38.674C19.017 41.284 25.267 43 32.85 43c2.464 0 4.858-.189 7.112-.563l-.321-1.974A42 42 0 0 1 32.85 41c-9.94 0-16.866-3.162-16.866-6V23.674C19.017 26.284 25.267 28 32.85 28s13.833-1.716 16.866-4.326V34H51.7V20c0-4.561-8.104-8-18.85-8S14 15.439 14 20v40.265C14 64.385 22.809 68 32.85 68c10.746 0 18.85-3.439 18.85-8v-4h13.89v-2H42.77z"
      />
    </g>
  </svg>
);
const Memo = memo(Timestream);
export default Memo;
